export const SEARCH_ROUTE = '';
export const SIGNUPS_ROUTE = 'signups';
export const SIGNUPS_VERIFICATION_FORM_ROUTE = 'signups/:providerId';
